import styled from 'styled-components';
import { FInter, FlexBox } from '@brg/ui';

export const SlideNavigationWrapper = styled(FlexBox)`
    flex-direction: column;
    width: 100%;
`;

export const SlideNavigationWrapperItem = styled(FInter.SmallTextBoldFlex)<{ active: boolean }>`
    color: ${(p) => (p.active ? p.theme.designerPage.slideLine : p.theme.designerPage.slideLineInActive)};
    cursor: pointer;
    transition: all 0.2s;
    padding-bottom: 10px;
    border-bottom: ${(p) => (p.active ? '2px solid #FEFEFE' : '2px solid transparent')};
    margin: -1.5px;
    & + & {
        margin-left: 24px;
    }
`;

export const SlideNavigationWrapperLine = styled.div`
    background: ${(p) => p.theme.designerPage.slideLine};
    opacity: 0.21;
    border: 1px solid ${(p) => p.theme.designerPage.slideLine};
    box-sizing: border-box;
    width: 100%;
    height: 1px;
`;
import styled from 'styled-components';
import { FInter, FlexBox } from '@brg/ui';

export const SlideNavigationWrapper = styled(FlexBox)`
    flex-direction: column;
    width: 100%;
`;

export const SlideNavigationWrapperItem = styled(FInter.SmallTextBoldFlex)<{ active: boolean }>`
    color: ${(p) => (p.active ? p.theme.designerPage.slideLine : p.theme.designerPage.slideLineInActive)};
    cursor: pointer;
    transition: all 0.2s;
    padding-bottom: 10px;
    border-bottom: ${(p) => (p.active ? '2px solid #FEFEFE' : '2px solid transparent')};
    margin: -1.5px;
    & + & {
        margin-left: 24px;
    }
`;

export const SlideNavigationWrapperLine = styled.div`
    background: ${(p) => p.theme.designerPage.slideLine};
    opacity: 0.21;
    border: 1px solid ${(p) => p.theme.designerPage.slideLine};
    box-sizing: border-box;
    width: 100%;
    height: 1px;
`;
